import { apiFetch } from "../utils/apiFetch";
import { API_BASE_CLIENT as API_BASE } from "../config/vars";

export async function fetchClientPortalSettings() {
    const res = await apiFetch(`${API_BASE}/client-portal/settings`);
    if (!res.ok) throw new Error("Не вдалося завантажити налаштування сторінки");
    return res.json();
}
